export default __webpack_public_path__ + "static/media/rabbit17.671aa093.gif";